import { render, staticRenderFns } from "./ViewSalesOrderComponent.vue?vue&type=template&id=5586b2f1&"
import script from "./ViewSalesOrderComponent.vue?vue&type=script&lang=js&"
export * from "./ViewSalesOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports